// extracted by mini-css-extract-plugin
module.exports = {"Buttons":"auth_Buttons__HaELr","Content":"auth_Content__Qwb6P","Change":"auth_Change__9wZIm","Error":"auth_Error__wkA51"};